/*
  VBRNTT blog: month pills filter the posts already on the page. City
  filtering is server-side (real tag links), so it works without this file;
  the month row stays hidden unless this runs. The selected month is kept in
  the hash (#2026-10) so it survives a reload and can be shared.
*/
if (!customElements.get('vbrntt-blog-months')) {
  customElements.define(
    'vbrntt-blog-months',
    class VbrnttBlogMonths extends HTMLElement {
      connectedCallback() {
        this.nav = this.querySelector('[data-month-nav]');
        this.posts = Array.from(this.querySelectorAll('[data-posts] > [data-month]'));
        if (!this.nav || !this.posts.length) return;
        this.pills = Array.from(this.nav.querySelectorAll('[data-month]'));
        this.nav.hidden = false;
        this.nav.addEventListener('click', (event) => {
          const pill = event.target.closest('[data-month]');
          if (!pill) return;
          this.select(pill.dataset.month, true);
        });
        const fromHash = window.location.hash.slice(1);
        this.select(this.pills.some((p) => p.dataset.month === fromHash) ? fromHash : 'all', false);
      }

      select(month, write) {
        this.pills.forEach((pill) => pill.setAttribute('aria-pressed', String(pill.dataset.month === month)));
        this.posts.forEach((post) => {
          post.hidden = month !== 'all' && post.dataset.month !== month;
        });
        if (write) {
          const url = month === 'all' ? window.location.pathname + window.location.search : `#${month}`;
          window.history.replaceState(window.history.state, '', url);
        }
      }
    }
  );
}
